module.exports = {
  intro: {
    alt: 'Lorinthe BV',
    title_1: 'webapp',
    title_2: 'ontwikkeling',
    payload_1: '<p>Voor nieuwe bedrijven die op zoek zijn naar moderne web applicaties ontwikkelt Lorinthe <b>user interfaces</b> en <b>web apps</b>.</p>',
    payload_2: ' <p>In tegenstelling tot algemene software bedrijven, hebben wij speciale expertise voor de "humanistische" doelgroepen zoals <b>cultuur</b>, <b>lifestyle</b>, <b>gezondheid</b> en <b>zorg</b>.'
  }
}
